import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import QuoteTile from 'components/QuoteTile'

const SevenBridgesQuoteTile = () => {
    return (
        <QuoteTile
            backgroundImageStaticQuery={useStaticQuery(graphql`
                query {
                    desktop: file(relativePath: { eq: "customerQuoteTiles/7bridges.png" }) {
                        childImageSharp {
                            fluid(quality: 90, maxWidth: 420) {
                                ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            `)}
            text={'Turning Scope 3 logistics emissions into competitive edge for customers  '}
            logo={
                <img
                    src="https://assets.lune.co/lune-co/client-logos/7bridges-colour.png"
                    alt="Seven Bridges logo"
                    height={32}
                />
            }
        />
    )
}

export default SevenBridgesQuoteTile
